module.exports = __webpack_public_path__ + "img/yuque.14addb70.svg";